import React from "react";

export default ({ad, classes}) => <div className={classes.root}>{ad}</div>;